import { SimpleOptionType } from 'types/filters';

import SelectCommon from '../common/SelectCommon/SelectCommon';
import { SelectValue } from '../filter.types';

interface StateSelectWrapperProps {
  value: SelectValue | undefined;
  placeholder: string;
  options: SimpleOptionType[] | undefined;
  onChange: (value: SelectValue) => void;
  loading: boolean;
  className?: string;
  disabled: boolean;
  hasAccessToFilter: boolean;
  title: string;
  notFoundContent?: string;
}

const StateSelectWrapper = ({
  value,
  placeholder,
  options,
  onChange,
  loading,
  className,
  disabled,
  hasAccessToFilter,
  title,
  notFoundContent
}: StateSelectWrapperProps) => (
  <SelectCommon
    title={title}
    value={value}
    placeholder={placeholder}
    options={options}
    onChange={onChange}
    optionFilterProp="children"
    loading={loading}
    className={className}
    disabled={disabled}
    singleMode
    hasAccessToFilter={hasAccessToFilter}
    notFoundContent={notFoundContent}
  />
);

export default StateSelectWrapper;
